import { Card, Skeleton } from "@mui/material";
import { ReactNode } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { pulseSx, surfaceCardSx } from "@/components/screens/ServiceDashboard/components/styles";

import Sparkline from "../Sparkline";
import VariationBadge from "../VariationBadge";

type Props = {
  title: string;
  value: ReactNode;
  suffix?: string;
  icon: ReactNode;
  color: string;
  variation: number | null | undefined;
  isPoints?: boolean;
  lowerIsBetter?: boolean;
  caption: string;
  series: (number | null)[];
  isLoading?: boolean;
  isRefreshing?: boolean;
};

const KpiTile = ({
  title,
  value,
  suffix,
  icon,
  color,
  variation,
  isPoints,
  lowerIsBetter,
  caption,
  series,
  isLoading,
  isRefreshing = false,
}: Props) => (
  <Card sx={surfaceCardSx()}>
    <MDBox p={1.5} display="flex" gap={1.25} height="100%" sx={pulseSx(isRefreshing)}>
      <MDBox
        width="2.25rem"
        height="2.25rem"
        minWidth="2.25rem"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRadius: "50% !important",
          backgroundColor: color,
          color: "#fff",
          "& svg": { fontSize: "1.2rem" },
        }}
      >
        {icon}
      </MDBox>
      <MDBox flex={1} minWidth={0} display="flex" flexDirection="column">
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color="dark"
          sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {title}
        </MDTypography>
        {isLoading ? (
          <Skeleton variant="text" height={36} width="70%" />
        ) : (
          <MDTypography variant="h4" fontWeight="bold" lineHeight={1.2}>
            {value}
            {suffix && (
              <MDTypography component="span" variant="button" fontWeight="regular" ml={0.5}>
                {suffix}
              </MDTypography>
            )}
          </MDTypography>
        )}
        <MDBox mt={0.5}>
          <VariationBadge value={variation} isPoints={isPoints} lowerIsBetter={lowerIsBetter} />
          <MDTypography variant="caption" color="text" display="block" lineHeight={1.3}>
            {caption}
          </MDTypography>
        </MDBox>
        <MDBox mt="auto" ml={-4.5} pt={0.5}>
          <Sparkline values={series} color={color} />
        </MDBox>
      </MDBox>
    </MDBox>
  </Card>
);

export default KpiTile;
